const components = {
  AppModal: defineAsyncComponent(() => import('@/components/AppModal.vue')),

  AddSchoolAdminModal: defineAsyncComponent(() => import('@/views/spencer-admin/school/components/AddSchoolAdminModal.vue')),
  CreateEditDomainModal: defineAsyncComponent(() => import('@/views/spencer-admin/questionnaires/components/CreateEditDomainModal.vue')),
  CreateEditQuestionModal: defineAsyncComponent(() => import('@/views/spencer-admin/questionnaires/components/CreateEditQuestionModal.vue')),
  CreateEditQuestionnaireModal: defineAsyncComponent(() => import('@/views/spencer-admin/questionnaires/components/CreateEditQuestionnaireModal.vue')),
  CreateEditThemeModal: defineAsyncComponent(() => import('@/views/spencer-admin/questionnaires/components/CreateEditThemeModal.vue')),
  CreateEditRecommendationModal: defineAsyncComponent(() => import('@/views/spencer-admin/questionnaires/components/CreateEditRecommendationModal.vue')),

  SetRoleModal: defineAsyncComponent(() => import('@/views/school-admin/directory/components/SetRoleModal.vue')),
  GiveAccessModal: defineAsyncComponent(() => import('@/views/school-admin/directory/components/GiveAccessModal.vue')),
  DeletePersonModal: defineAsyncComponent(() => import('@/views/school-admin/directory/components/DeletePersonModal.vue')),
  AddNewGroupModal: defineAsyncComponent(() => import('@/features/groups/components/AddNewGroupModal.vue')),
  AddNewStudentToGroupModal: defineAsyncComponent(() => import('@/features/groups/components/AddNewStudentToGroupModal.vue')),
  TransferStudentModal: defineAsyncComponent(() => import('@/views/school-admin/students/components/TransferStudentModal.vue')),

  OneTimeRecurringProfileModal: defineAsyncComponent(() => import('@/views/need-manager/students/components/OneTimeRecurringProfileModal.vue')),
  ProfileRecommendationInfoModal: defineAsyncComponent(() => import('@/components/profile-recommendation/ProfileRecommendationInfoModal.vue')),
  NeedManagerRecommendationsAddedModal: defineAsyncComponent(() => import('@/views/need-manager/recommendations/components/NeedManagerRecommendationsAddedModal.vue'))
} as const

type TComponentsType = typeof components
type TComponentNames = keyof TComponentsType

type TInferProps<T> = T extends new (...args: any[]) => infer R
  ? R extends { $props: infer P } ? P: never
  : never

type TComponentProps = {
  [K in TComponentNames]: TInferProps<TComponentsType[K]>
}

const modals = ref(new Map<TComponentNames, { component: any; props?: any; isOpen: boolean}>())

export function useModals () {
  function open<K extends TComponentNames> (name: K, props?: TComponentProps[K]) {
    modals.value.set(name, { component: markRaw(components[name]), props, isOpen: true })
  }

  function close (name: TComponentNames) {
    const modal = modals.value.get(name)
    if (modal) {
      modal.isOpen = false
    }
  }

  const isOpen = computed(() => {
    return [...modals.value.entries()].reduce((acc, [name, { isOpen }]) => {
      acc[name] = isOpen
      return acc
    }, {} as Record<TComponentNames, boolean>)
  })
  return {
    modals,
    isOpen,
    open,
    close
  }
}
